export const AcidGreen = '#BDBF09';
export const AntiqueFuchsia = '#875C74';
export const Black = '#000000';
export const BlueGreen = '#004d40';
export const BrandyPunch = '#ce8f28';
export const BrownSugar = '#B4654A';
export const Cadet = '#5A7881';
export const Capri = '#5CC8FF';
export const Celeste = '#CDFFF9';
export const Cerise = '#D1345B';
export const Charcoal = '#37474f';
export const ChartreuseTraditional = '#E4FF1A';
export const Citron = '#9EA93F';
export const Cultured = '#eceff1';
export const DarkOrange = '#FF8811';
export const DarkPurple = '#0F0326';
export const DeepSpaceSparkle = '#335C67';
export const Eggplant = '#75485E';
export const EnglishVermillion = '#D64045';
export const Flame = '#cf5c36';
export const FruitSalad = '#509f60';
export const GrannySmithApple = '#ADF6B1';
export const Grullo = '#A69888';
export const IlluminatingEmerald = '#3E9276';
export const ImperialRed = '#EF233C';
export const InternationalGoldenGateBridge = '#BB4430';
export const Magnolia = '#F3EFF5';
export const MaizeCrayola = '#E8C547';
export const Mango = '#F7B801';
export const MangoTango = '#F5853F';
export const MaximumBlue = '#42BFDD';
export const MiddleRedPurple = '#AF5D63';
export const OuterSpaceCrayola = '#22363C';
export const PersianGreen = '#009688';
export const Platinum = '#E5E5E5';
export const Pomegranate = '#f44336';
export const RedRYB = '#FF220C';
export const Rosewood = '#5E0B15';
export const Ruby = '#D81E5B';
export const RubyRed = '#A31621';
export const RussianGreen = '#678D58';
export const Safron = '#EAC435';
export const SeaGreenCrayola = '#0FFFC1';
export const SlimyGreen = '#2B9720';
export const SpanishGreen = '#058E3F';
export const Spectra = '#315460';
export const TeaGreen = '#CAE7B9';
export const TucanRed = '#754043';
export const TumbleWeed = '#CEA07E';
export const TwilightLavander = '#754668';
export const UARed = '#E01A4F';
export const VioletColorWheel = '#7E0FFF';
export const White = '#ffffff';
export const WildBlueYonder = '#99B2DD';
